import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { LargeListFilterFactory } from '../LargeListFilterFactory';

export const CountryFilter = LargeListFilterFactory<string>(
  getFilterMetadata(FilterKindEnum.Country),
  'Enter a country name...',
);
